import config from 'config';
import { Cookies } from 'core/utilities';
import { user } from 'core';
import { cleanUpAccessToken } from 'core/services/auth';

export const useLogout = () => {
  const {
    data: { resellerId },
  } = user.hooks.useUser();

  const handleLogout = () => {
    cleanUpAccessToken();
    localStorage.removeItem('is-ir');
    localStorage.removeItem(`choose-extended-cycle-${resellerId}`);
    localStorage.removeItem(`choose-new-cycle-${resellerId}`);
    localStorage.removeItem(`persist:${config.app.short}-stargate`);

    Cookies.remove('currentCycle');
    Cookies.remove('sessionId');
    Cookies.remove('isMultiBrand');
    Cookies.remove('tokenAutorizacao');

    window.location.href = `${config?.app?.logout}${document.location.search}`;
  };

  return { handleLogout };
};
